import Swiper from 'swiper/bundle';
import 'swiper/css/bundle';
import Vivus from 'vivus';
import { vivusAnimationDuration } from "./vivusDurationcalc.js";

export function initSwiper() {
  const swiper = new Swiper(".swiper", {
    loop: true,
    speed: 500,
    effect: 'fade',
    fadeEffect: {
      crossFade: true
    },
    pagination: {
      el: ".swiper-pagination",
      clickable: true,
    },
    navigation: {
      nextEl: ".swiper-button-next",
      prevEl: ".swiper-button-prev",
    },
  });

  const navItems = document.querySelectorAll('.sv_sldNav_item');

  // ナビクリック → スライド
  navItems.forEach((item, index) => {
    item.addEventListener('click', () => {
      swiper.slideToLoop(index);
    });
  });

  // スライド切り替え → ナビ更新 & Vivus起動
  swiper.on('slideChange', () => {
    const realIndex = swiper.realIndex;

    navItems.forEach((item, i) => {
      const letteringEl = item.querySelector('.sv_sldNav_lettering');

      if (i === realIndex) {
        item.classList.add('is_active');

        if (letteringEl) {
          // Vivus起動
          new Vivus(letteringEl, {
            type: 'delayed',   // アニメーションタイプ
            duration: vivusAnimationDuration(300),
            start: 'autostart',
            animTimingFunction: Vivus.EASE_OUT, // 自動開始
          });
        }

      } else {
        item.classList.remove('is_active');
      }
    });
  });

  // 初期状態
  navItems[0]?.classList.add('is_active');
  const firstLettering = navItems[0]?.querySelector('.sv_sldNav_lettering');
  if (firstLettering) {
    new Vivus(firstLettering, {
      type: 'delayed',
      // duration: 400,
      duration: vivusAnimationDuration(300),
      start: 'autostart',
      animTimingFunction: Vivus.EASE_OUT,
    });
  }

  return swiper;
}
